
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'vue';
import 'lodash/get';
import { P as PendoLoading } from './pendo-loading-mixin.js';

function getDefault(key) {
  return PendoLoading.options[key];
}

const SIZE_MAP = {
  small: 16,
  medium: 32,
  large: 48
};
var script = {
  name: 'PendoLoadingIndicator',
  directives: {
    PendoLoading
  },
  props: {
    size: {
      type: String,
      default: 'medium'
    },
    light: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: true
    },
    button: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'material'
    },
    text: {
      type: String,
      default: () => getDefault('text')
    },
    textClass: {
      type: String,
      default: () => getDefault('textClass')
    },
    overlayProps: {
      type: Object,
      default: () => ({})
    },
    spinnerProps: {
      type: Object,
      default: () => ({})
    },
    skeletonProps: {
      type: Object,
      default: () => ({})
    },
    preventRelativeParent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loaderConfig() {
      const loading = this.loading,
            light = this.light,
            type = this.type,
            text = this.text,
            textClass = this.textClass,
            preventRelativeParent = this.preventRelativeParent,
            spinnerProps = this.spinnerProps,
            skeletonProps = this.skeletonProps,
            overlayProps = this.overlayProps;
      const size = this.$options.propsData.size;
      const conditionalSpinnerProps = {};

      if (!!light) {
        conditionalSpinnerProps.color = '#F8F8F9';
      }

      if (size && isNaN(size)) {
        conditionalSpinnerProps.size = SIZE_MAP[size];
      }

      return {
        loading,
        type,
        text,
        textClass,
        preventRelativeParent,
        overlayProps: _objectSpread({}, getDefault('overlayProps'), overlayProps, {
          position: 'inherit'
        }),
        spinnerProps: _objectSpread({}, getDefault('spinnerProps'), {
          background: 'transparent'
        }, spinnerProps, conditionalSpinnerProps),
        skeletonProps: _objectSpread({}, getDefault('skeletonProps'), skeletonProps)
      };
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "pendo-loading",
      rawName: "v-pendo-loading",
      value: _vm.loaderConfig,
      expression: "loaderConfig"
    }]
  });
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-loading-indicator.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoLoadingIndicator = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoLoadingIndicator;
